<template>
  <Modal :modal="mfaSetupModalRef" :steps="[{ component: MfaSetupContent, id: 'mfa-setup' }]" />
</template>

<script lang="ts" setup>
import MfaSetupContent from '@/features/auth/components/mfa-setup-modal/mfa-setup-content/mfa-setup-content.vue'
import Modal from '@/features/ui/components/modal/modal.vue'
import { selectGetMfaSetupModal } from '@/features/ui/store/modal/modal.selectors'
import modalsStore from '@/features/ui/store/modal/modal.store'

const mfaSetupModalRef = selectGetMfaSetupModal(modalsStore)
</script>
